export interface LoginRequest {
  username: string
  password: string
}

export interface LoginResponse {
  token?: string
  error?: string
}

export async function login(request: LoginRequest): Promise<LoginResponse> {
  const response = await fetch('/umbraco/api/member/member/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(request),
  })

  if (!response.ok) {
    throw new Error('Network response was not ok')
  }

  const data = await response.json()
  return data
}
